
'use strict'

import Billboards from "../../libs/API/Billboards";
import { formatPrice, stringToDate, GTMEvent, dateToString, sanitizeHtml } from "../../utils/Utils";
import ShoppingCartItem from './ShoppingCartItem';
import Notification from "../Notification";
import Alert from "../Alert";
import BrandCategories from "../../libs/API/BrandCategories";
import BillboardListConfirmItemReplace from "../BillboardListConfirmItemReplace";
import Brands from "../../libs/API/Brands";
import Auth from "../../libs/API/Auth";

const TYPE_BRAND = 'BRAND';
const TYPE_BRAND_CATEGORY = 'BRAND_CATEGORY';

class ShoppingCartClass {

    get TYPE_BRAND() { return TYPE_BRAND };// Dejo las constantes accesibles desde afuera
    get TYPE_BRAND_CATEGORY() { return TYPE_BRAND_CATEGORY };// Dejo las constantes accesibles desde afuera

    constructor() {
        this.main = document.getElementById('shopping_cart');
        this._wrapper = this.main.querySelector('.wrapper');

        this._closeBtn = this.main.querySelector('.close_btn');

        this._holderItems = this.main.querySelector('.holder_items');

        this._totalPriceStatic = this.main.querySelector('.total_price_static');
        this._totalPriceDigital = this.main.querySelector('.total_price_digital');
        this._totalPrice = this.main.querySelector('.total_price');
        this._continueToCheckout = this.main.querySelector('.continue_to_checkout');

        this._rowTotalStatic = this.main.querySelector('.row_total_static');
        this._rowTotalDigital = this.main.querySelector('.row_total_digital');

        this._totalCountStatic = this.main.querySelector('.total_count_static');
        this._totalCountDigital = this.main.querySelector('.total_count_digital');

        this._clearAllBtn = this.main.querySelector('.clear_all');

        this._campaignName = null;
        this._currentBrandCategory = null;
        this._currentBrand = null;
        this._AICredits = null;

        this._cartType = false; // Define si está armando un carrito para una 'brand' o para 'brand_category'

        this._brandCategoryOrBrandLabel = this.main.querySelector('.brand_category_or_brand_label');

        this._items = [];

        this._prevData = null;
        this._currentData = null;

        this._isReady = false;
        this._initSilent = false;

        this._closeBtn.addEventListener('click', this._onClickCloseBtn.bind(this));
        this._clearAllBtn.addEventListener('click', this._onClickClearAllBtn.bind(this));
        this.main.addEventListener('SHOPPING_CART_ITEM_REMOVE', this._onItemRemove.bind(this));
        this.main.addEventListener('SHOPPING_CART_PACKAGE_REMOVE', this._onPackageRemove.bind(this));
        this._wrapper.addEventListener('click', e => e.stopPropagation());
        this.main.addEventListener('click', this.hide.bind(this));
        window.addEventListener('storage', this._onStorageChange.bind(this));


        Auth.addEventListener('sessionReady', this._onSessionReady.bind(this));

    }

    _onSessionReady(isUserLogged) {
        if (document.readyState === 'loading') {
            document.addEventListener("DOMContentLoaded", () => this._init(isUserLogged).bind(this));
        } else {
            this._init(isUserLogged);
        }
    }

    _init(isUserLogged) {
        if (isUserLogged) {
            this._loadList().then(() => {
                this._isReady = true;
                this.main.dispatchEvent(new CustomEvent('cartReady'));
            })
        } else {
            this.clear();
        }
    }

    show() {
        this.main.classList.add('shopping-cart--show');
        setTimeout(() => {
            document.body.classList.add('block-scroll');
        }, 0);
    }

    hide() {
        this.main.classList.remove('shopping-cart--show');

        setTimeout(() => {
            document.body.classList.remove('block-scroll');
        }, 0);
    }

    addEventListener(event, callback) {
        this.main.addEventListener(event, callback);
    }

    get fromDate() {
        const dates = this._items.map(item => item.data.dateRange.from);
        return new Date(Math.min.apply(null, dates));
    }

    get toDate() {
        const dates = this._items.map(item => item.data.dateRange.to);
        return new Date(Math.max.apply(null, dates));
    }
 
    get itemsCount() {
        return this._items.length;
    }

    get isReady() {
        return this._isReady;
    }

    get data() {
        let data = JSON.parse(JSON.stringify(this._currentData));

        data.items.forEach((item) => {
            item.dateRange.from = stringToDate(item.dateRange.from.split('T')[0]);
            item.dateRange.to = stringToDate(item.dateRange.to.split('T')[0]);
        })

        return data;
    }

    // Setea la variable _initSilent. Si es true, cuando se inicie el cart no va a notificar de cambios en la lista
    set initSilent(value) {
        this._initSilent = value;
    }

    set campaignName(value) {
        this._campaignName = value;
        this._update();
    }

    set setAICredits(value) {
        this._AICredits = value;
        this._update();
    }

    get getCampaignName() {
        return this._campaignName;
    }

    get getTotalCartNumber() {
        return parseFloat(this._totalPrice.textContent.replace(/[$,]/g, "")).toFixed(2);
    }

    async add(billboardId, dateRange, exclusivity = false, brandId = null, brandCategoryId = null, weekdays = null, packageId = null) {
        // Sino hay ni brand ni brand category muestro error
        if (brandCategoryId == null && brandId == null) {
            Alert.show('warning', 'Can\'t add selected item', `Item doesn't have a brand or category`);

            return Promise.resolve(false);
        }

        // Si el carrito está vacio defino en funcion del item si va a ser un carrito de brand o de brand category
        if (this._currentBrandCategory == null && this._currentBrand == null) {
            this._cartType = brandId != null ? TYPE_BRAND : TYPE_BRAND_CATEGORY;
        }


        if (this._cartType == TYPE_BRAND) {
            if (this._currentBrand == null || this._currentBrand.name == null) {
                this._currentBrand = await Brands.getBrandById(brandId, ['id', 'name']);
            }

            if (brandId != this._currentBrand.id || brandCategoryId != null) {
                Alert.show('warning', 'Can\'t add selected item', `You are currently planning your campaign for ${this._currentBrand.name}`);

                return Promise.resolve(false);
            }


        } else if (this._cartType == TYPE_BRAND_CATEGORY) {
            if (this._currentBrandCategory == null || this._currentBrandCategory.name == null) {
                this._currentBrandCategory = await BrandCategories.getBrandCategoryById(brandCategoryId);
            }

            if (brandCategoryId != this._currentBrandCategory.id || brandId != null) {
                Alert.show('warning', 'Can\'t add selected item', `You are currently planning your campaign for ${this._currentBrandCategory.name} category`);

                return Promise.resolve(false);
            }
        }

        let fields = ['id', 'name', 'slug', 'is_prime', 'price', 'original_price', 'days_available', 'exclusivity', 'format', 'package', 'location'];

        const dateRanges = this._splitDateRange(billboardId, dateRange, packageId);

        for (const dateRange of dateRanges) {
            let data = await Billboards.getBillboardById(billboardId, fields, dateRange, exclusivity, brandId, brandCategoryId, weekdays, null, packageId);
            data.dateRange = dateRange;
            data.brand_id = this._cartType == TYPE_BRAND ? this._currentBrand.id : null;
            data.brand_category_id = this._cartType == TYPE_BRAND_CATEGORY ? this._currentBrandCategory.id : null;
            data.weekdays = weekdays;
            await this._addItemToCart(data);
        }
    }

    remove(billboardId, dateRange) {
        this._currentData.items.forEach((itemData, index) => {
            if (itemData.id == billboardId && itemData.dateRange.from.getTime() == dateRange.from.getTime() && itemData.dateRange.to.getTime() == dateRange.to.getTime()) {
                this._removeByIndex(index, itemData);
                return true;
            }
        })

        return false;
    }

    changeItemExclusivity(billboardId, dateRange, exclusivity, weekdays, packageId = null) {
        let itemIndex = null;

        for (let i = 0; i < this._items.length; i++) {
            let itemData = this._items[i].data;

            if (itemData.id == billboardId && itemData.dateRange.from.getTime() == dateRange.from.getTime() && itemData.dateRange.to.getTime() == dateRange.to.getTime()) {
                itemIndex = i;
                break;
            }
        }

        if (itemIndex != null) {
            let fields = ['id', 'name', 'slug', 'is_prime', 'price', 'days_available', 'exclusivity', 'format', 'package', 'original_price'];

            let brandId = this._cartType == TYPE_BRAND ? this._currentBrand.id : null;
            let brandCategoryId = this._cartType == TYPE_BRAND_CATEGORY ? this._currentBrandCategory.id : null;


            return Billboards.getBillboardById(billboardId, fields, dateRange, exclusivity, brandId, brandCategoryId, weekdays, true, packageId)
                .then((data) => {
                    data.dateRange = dateRange;
                    data.brand_id = brandId;
                    data.brand_category_id = brandCategoryId;
                    data.weekdays = weekdays;
                    data.package = packageId ? { id: packageId } : null;
                    data.format = { name: data.format.name };

                    let newItem = new ShoppingCartItem(data);
                    this._items[itemIndex].main.replaceWith(newItem.main);

                    this._items[itemIndex] = newItem;

                    this._update();

                    return Promise.resolve(true);
                })
        } else {
            return Promise.resolve(false);
        }

    }

    clear() {
        this._holderItems.innerHTML = '';
        this._items = [];

        this._prevData = null;
        this._currentData = null;
        this._currentBrand = null;
        this._currentBrandCategory = null;
        this._cartType = false;
        this._campaignName = null;

        this._update();
    }

    clearWithoutEvents() {
        this._holderItems.innerHTML = '';
        this._items = [];

        this._prevData = null;
        this._currentData = null;
        this._currentBrand = null;
        this._currentBrandCategory = null;
        this._cartType = false;
        this._campaignName = null;

        this._update(true, false);
    }

    _sortByFormat(elementArray) {
        elementArray.sort((a, b) => {
            const formatA = a.format.name.toUpperCase();
            const formatB = b.format.name.toUpperCase();

            if (formatA < formatB) {
                return -1;
            }
            if (formatA > formatB) {
                return 1;
            }
            return 0;
        });
    }

    // Valida la lista de localstorage con el server e inserta los items indicando si cambió algo
    _loadList() {
        return new Promise((resolve, reject) => {
            let prevData = JSON.parse(localStorage.getItem('shopping_cart'));

            if (prevData == null || prevData.items.length == 0) {
                if (prevData && (prevData.brand || prevData.brandCategory)) {
                    this._cartType = prevData.cartType;
                    this._currentBrand = prevData.brand;
                    this._currentBrandCategory = prevData.brandCategory;
                    this._currentData = {
                        campaignName: this._campaignName,
                        cartType: this._cartType,
                        brand: this._currentBrand,
                        brandCategory: this._currentBrandCategory,
                        items: []
                    }
                } else {
                    this.clear();
                }

                resolve();
                return;
            }

            this._campaignName = prevData.campaignName;
            this._cartType = prevData.cartType;
            this._currentBrand = prevData.brand;
            this._currentBrandCategory = prevData.brandCategory;

            this._holderItems.innerHTML = '';
            this._items = [];

            let requestData = {};

            requestData.brand_id = this._cartType == TYPE_BRAND ? this._currentBrand.id : null;
            requestData.brand_category_id = this._cartType == TYPE_BRAND_CATEGORY ? this._currentBrandCategory.id : null;
            requestData.items = [];

            this._sortByFormat(prevData.items);
            prevData.items.forEach((item) => {
                item.dateRange.from = item.dateRange.from.split('T')[0];
                item.dateRange.to = item.dateRange.to.split('T')[0]

                requestData.items.push({
                    id: item.id,
                    date_range: [item.dateRange.from, item.dateRange.to],
                    date_filters: {
                        weekdays: item.weekdays,
                    },
                    exclusivity: item.exclusivity,
                    package: item.package,
                    format: { name: item.format },
                    exclusivity: item.exclusivity
                });
            });
            // Envío los ids con sus respectivos dateRange para obtener la data actualizada
            fetch(`${BASE_URL}shopping-cart/update-list`, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(requestData)

            })
                .then(response => response.json())
                .then((data) => {
                    let dateRangeChanged = false;
                    let daysAvailableChanged = false;
                    let priceChanged = false;

                    // Inserto los nuevos items y comparon con la tada previa por si cambió algo (disponibilidad, precio, etc)

                    this._sortByFormat(data);
                    data.forEach((itemData, index) => {
                        itemData.dateRange = { from: itemData.date_range[0], to: itemData.date_range[1] };
                        delete itemData.date_range;// Elimino esta propiedad porque no se va a usar más

                        let prevDataItem = prevData.items.find(item =>
                            item.id == itemData.id &&
                            item.dateRange.from == itemData.dateRange.from &&
                            item.dateRange.to == itemData.dateRange.to
                        );

                        if (!prevDataItem) {
                            prevDataItem = prevData.items.find(item => item.id == itemData.id);
                            if (!prevDataItem) {
                                return;
                            }
                        }

                        if (prevDataItem.dateRange.from != itemData.dateRange.from || prevDataItem.dateRange.to != itemData.dateRange.to) {
                            dateRangeChanged = true;
                        }

                        if (prevDataItem.days_available != itemData.days_available) {
                            daysAvailableChanged = true;
                        }

                        if (prevDataItem.price != itemData.price) {
                            priceChanged = true;
                        }

                        // Convierto date strings a dates
                        itemData.dateRange.from = stringToDate(itemData.dateRange.from);
                        itemData.dateRange.to = stringToDate(itemData.dateRange.to);

                        itemData.brand_id = this._cartType == TYPE_BRAND ? this._currentBrand.id : null;;
                        itemData.brand_category_id = this._cartType == TYPE_BRAND_CATEGORY ? this._currentBrandCategory.id : null;
                        itemData.weekdays = prevDataItem.weekdays;
                        //itemData.format = prevDataItem.format;

                        let item = new ShoppingCartItem(itemData);
                        this._addItemToHolder(item);
                        this._items.push(item);

                    })


                    this._update();

                    if (!this._initSilent && (dateRangeChanged || daysAvailableChanged || priceChanged)) {

                        let msg = 'Some items on your list have changed some of these attributes: ';
                        msg += dateRangeChanged ? 'date range, ' : '';
                        msg += daysAvailableChanged ? 'days available, ' : '';
                        msg += priceChanged ? 'price, ' : '';
                        msg = msg.slice(0, -2) + '.';

                        /* Alert.show('warning', 'Warning', msg).then((confirm)=>{
                            if(confirm){
                                this.show();
                            }
                        }) */

                        Notification.show(msg, 'warning', null, null, 5000);


                    }

                    resolve();
                })
        });
    }

    _onItemRemove(e) {
        e.stopPropagation();

        let itemIndex = this._items.indexOf(e.detail.item);
        this._removeByIndex(itemIndex, e.detail.item);
    }

    _removeByIndex(itemIndex, item) {
        let msg = `The billboard has been removed`;


        Notification.show(msg, null, 'undo', 'link').then((clickBtn) => {
            if (clickBtn) {
                this._undo();
            }
        })

        this._holderItems.removeChild(this._items[itemIndex].main);
        this._items.splice(itemIndex, 1);

        if (this._items.length == 0) {
            this._currentBrandCategory = null;
            this._currentBrand = null;
            this._cartType = false;
        }

        GTMEvent('remove_from_cart', {
            ecommerce: {
                currency: 'USD',
                tax: '0',
                shipping: '0',
                value: (item._data != undefined ? item._data.price : item.price),
                items: [
                    { item_id: (item._data != undefined ? item._data.id : item.id), item_name: (item._data != undefined ? item._data.name : item.name), price: (item._data != undefined ? item._data.price : item.price), quantity: '1' }
                ]
            }
        });

        this._update();
    }


    _onPackageRemove(e) {
        e.stopPropagation();

        this.removePackageById(e.detail.package_id);

        Notification.show('The package has been removed', null, 'undo', 'link').then((clickBtn) => {
            if (clickBtn) {
                this._undo();
            }
        });
    }

    async removePackageById(packageId) {
        return new Promise((resolve, reject) => {
            const packageItems = this._items.filter((item) => item.data.package && item.data.package.id == packageId);
            this._holderItems.removeChild(packageItems[0].main.closest('.package_holder'));

            for (const packageItem of packageItems) {
                let itemIndex = this._items.indexOf(packageItem);
                this._items.splice(itemIndex, 1);
            }

            if (this._items.length == 0) {
                this._currentBrandCategory = null;
                this._currentBrand = null;
                this._cartType = false;
            }

            this._update();

            resolve();
        });
    }

    _onClickCloseBtn(e) {
        this.hide();
    }

    _onClickClearAllBtn(e) {
        e.preventDefault();

        this.clear();
    }

    _onStorageChange(e) {
        if (!document.hasFocus() && e.key == 'shopping_cart') {
            let data = JSON.parse(localStorage.getItem('shopping_cart'));

            this._holderItems.innerHTML = '';
            this._items = [];

            this._campaignName = data.campaignName;
            this._cartType = data.cartType;
            this._currentBrand = data.brand;
            this._currentBrandCategory = data.brandCategory;

            data.items.forEach((itemData) => {
                itemData.dateRange.from = stringToDate(itemData.dateRange.from.split('T')[0]);
                itemData.dateRange.to = stringToDate(itemData.dateRange.to.split('T')[0]);

                let item = new ShoppingCartItem(itemData);
                this._addItemToHolder(item);
                this._items.push(item);

            })

            this._update(false);

        }
    }

    //Vuelve atrás al último cambio
    _undo() {
        if (this._prevData != null) {
            this._currentBrandCategory = this._prevData.brandCategory;

            this._holderItems.innerHTML = '';
            this._items = [];

            this._prevData.items.forEach((itemData) => {
                let item = new ShoppingCartItem(itemData);
                this._addItemToHolder(item);
                this._items.push(item);
            })

            this._update();
        }

    }

    _update(updateStorage = true, dispatchEvent = true) {
        if (this._currentBrand && this._currentBrand.is_demo) {
            this.main.classList.add('shopping-cart--demo');
            this._continueToCheckout.classList.add('button--disabled');
        } else {
            this.main.classList.remove('shopping-cart--demo');
            this._continueToCheckout.classList.remove('button--disabled');
        }

        this._prevData = this._currentData;

        let totalPriceDigital = 0;
        let totalPriceStatic = 0;
        let countDigital = 0;
        let countStatic = 0;
        let totalPrice = 0;

        this._currentData = {
            campaignName: this._campaignName,
            ai_credits: this._AICredits,
            cartType: this._cartType,
            brand: this._currentBrand,
            brandCategory: this._currentBrandCategory,
            items: []
        }

        this._items.forEach((item) => {
            if (item.data.format.name == 'Static') {
                totalPriceStatic += item.data.price;
                countStatic += 1;
            } else {
                totalPriceDigital += item.data.price;
                countDigital += 1;
            }
            totalPrice += item.data.price;

            this._currentData.items.push(item.data);
            /* this._currentData.items.push({
                id: item.data.id,
                dateRange: item.data.dateRange,
                exclusivity: item.data.exclusivity,
                price: item.data.price,
                days_available: item.data.days_available
            }); */
        });
        this._totalPrice.innerHTML = formatPrice(totalPrice);

        if (countStatic >= 1) {
            this._totalCountStatic.innerHTML = countStatic;
            this._totalPriceStatic.innerHTML = formatPrice(totalPriceStatic);
            this._rowTotalStatic.classList.remove('d-none');
        } else {
            this._rowTotalStatic.classList.add('d-none');
        }

        if (countDigital >= 1) {
            this._totalCountDigital.innerHTML = countDigital;
            this._totalPriceDigital.innerHTML = formatPrice(totalPriceDigital);
            this._rowTotalDigital.classList.remove('d-none');
        } else {
            this._rowTotalDigital.classList.add('d-none');
        }

        if (this._items.length == 0) {
            this.main.classList.add('shopping-cart--empty');
        } else {
            this.main.classList.remove('shopping-cart--empty');

            if (this._cartType == TYPE_BRAND) {
                this._brandCategoryOrBrandLabel.querySelector('.type').innerHTML = 'Brand';
                this._brandCategoryOrBrandLabel.querySelector('.name').innerHTML = this._currentBrand.name
            } else if (this._cartType == TYPE_BRAND_CATEGORY) {
                this._brandCategoryOrBrandLabel.querySelector('.type').innerHTML = 'Category';
                this._brandCategoryOrBrandLabel.querySelector('.name').innerHTML = this._currentBrandCategory.name
            }
        }

        if (updateStorage) {
            localStorage.setItem('shopping_cart', JSON.stringify(this._currentData));
        }

        if (dispatchEvent) {
            this.main.dispatchEvent(new CustomEvent('cartChange'));
        }

    }

    async _addItemToCart(data) {
        const conflictItemIndex = this._getConflictIndex(data);
        let msg = 'Added to your list.';

        if (conflictItemIndex !== null) {
            let itemData = this._items[conflictItemIndex].data;

            if (
                itemData.dateRange.from.getTime() == data.dateRange.from.getTime()
                && itemData.dateRange.to.getTime() == data.dateRange.to.getTime()
                && itemData.exclusivity == data.exclusivity
                && ((itemData.package && data.package) ? itemData.package.id == data.package.id : itemData.package == data.package)
            ) {
                Notification.show('Already in your list', null, 'view list', 'link').then((clickBtn) => {
                    if (clickBtn) {
                        this.show();
                    }
                });
                return;
            } else {
                const confirm = await BillboardListConfirmItemReplace.show(data, this._items[conflictItemIndex].data);
                if (!confirm) {
                    return;
                }

                this._holderItems.removeChild(this._items[conflictItemIndex].main);
                this._items.splice(conflictItemIndex, 1);
                msg = 'Replaced in your list.';
            }
        }

        let item = new ShoppingCartItem(data);
        this._addItemToHolder(item);
        this._items.unshift(item);
        this._update();

        Notification.show(msg, 'done', 'view list', 'link').then((clickBtn) => {
            if (clickBtn) {
                this.show();
            }
        });
    }

    _splitDateRange(billboardId, dateRange, packageId) {
        let dateRanges = [];
        let conflictPackageItems = this._getConflictPackageItems(billboardId, dateRange, packageId);

        if (conflictPackageItems.length == 0) {
            dateRanges.push(dateRange);
        }

        if (conflictPackageItems.length > 0) {
            const packageItem = conflictPackageItems[0].data;

            if (dateRange.to > packageItem.dateRange.to) {
                if (dateRange.from >= packageItem.dateRange.from) {
                    dateRange.from = new Date(
                        (new Date(packageItem.dateRange.to.getTime()))
                            .setDate(packageItem.dateRange.to.getDate() + 1)
                    );
                    dateRanges.push(dateRange);
                }

                if (dateRange.from < packageItem.dateRange.from) {
                    let dataBeforeFrom = JSON.parse(JSON.stringify(dateRange));
                    dataBeforeFrom.from = new Date(dataBeforeFrom.from);
                    dataBeforeFrom.to = new Date(
                        (new Date(packageItem.dateRange.from.getTime()))
                            .setDate(packageItem.dateRange.from.getDate() - 1)
                    );
                    dateRanges.push(dataBeforeFrom);

                    let dataAfterTo = JSON.parse(JSON.stringify(dateRange));
                    dataAfterTo.to = new Date(dataAfterTo.to);
                    dataAfterTo.from = new Date(
                        (new Date(packageItem.dateRange.to.getTime()))
                            .setDate(packageItem.dateRange.to.getDate() + 1)
                    );
                    dateRanges.push(dataAfterTo);
                }
            }

            if (dateRange.to <= packageItem.dateRange.to) {
                dateRange.to = new Date(
                    (new Date(packageItem.dateRange.from.getTime()))
                        .setDate(packageItem.dateRange.from.getDate() - 1)
                );
                dateRanges.push(dateRange);
            }
        }

        return dateRanges;
    }

    _getConflictIndex(data) {
        for (let i = 0; i < this._items.length; i++) {
            if (this._items[i].data.id == data.id
                && !(data.dateRange.to < this._items[i].data.dateRange.from || data.dateRange.from > this._items[i].data.dateRange.to)
            ) {
                return i;
            }
        }
        return null;
    }

    _getConflictPackageItems(billboardId, dateRange, packageId) {
        let conflictItems = [];
        for (let i = 0; i < this._items.length; i++) {
            if (this._items[i].data.id == billboardId && !(dateRange.to < this._items[i].data.dateRange.from || dateRange.from > this._items[i].data.dateRange.to)) {
                conflictItems.push(this._items[i]);
            }
        }
        return conflictItems.filter((item) => item.data.package != null && item.data.package.id != packageId);
    }

    _onClickDeletePackageBtn(e) {
        const packageId = e.target.closest('.package_holder').dataset.packageId;

        this.main.dispatchEvent(new CustomEvent('SHOPPING_CART_PACKAGE_REMOVE', {
            bubbles: true,
            detail: {
                package_id: packageId,
            }
        }));
    }

    _addItemToHolder(item) {
        if (item.data.package) {
            let packageHolder = this._holderItems.querySelector(`.package_holder[data-package-id="${item.data.package.id}"]`);
            if (!packageHolder) {
                const divElement = document.createElement('div');
                const htmlString = `<div class="shopping-cart__billboards-package package_holder" data-package-id="${item.data.package.id}" data-package-name="${item.data.package.name}">
                  <div class="row no-gutters pb-2">
                    <div class="col"><span class="shopping-cart__billboard-package-name">${sanitizeHtml(item.data.package.name)}</span></div>
                    <div class="col-auto"><span class="shopping-cart__remove-item delete_package_btn"><i class="material-icons material-icons--type-outlined material-icons--size-3">delete</i></span></div>
                  <div>
                </div>`;
                divElement.innerHTML = htmlString.trim();
                packageHolder = divElement.firstChild;
                packageHolder.querySelector('.delete_package_btn').addEventListener('click', this._onClickDeletePackageBtn.bind(this));
                this._holderItems.insertAdjacentElement('afterbegin', packageHolder);
            }
            packageHolder.appendChild(item.main);
        } else {
            this._holderItems.insertAdjacentElement('beforeend', item.main);
        }
    }

    setDefaultBrandId(value) {
        if (this._currentData && this._currentData.items.length == 0) {
            this._currentBrand = { id: value };
            this._currentBrandCategory = null;
            this._cartType = TYPE_BRAND;
            this._update(true, false);
        }
    }

    setDefaultBrandCategoryId(value) {
        if (this._currentData && this._currentData.items.length == 0) {
            this._currentBrandCategory = { id: value };
            this._currentBrand = null;
            this._cartType = TYPE_BRAND_CATEGORY;
            this._update(true, false);
        }
    }
}


const ShoppingCart = new ShoppingCartClass();
Object.seal(ShoppingCart);

export default ShoppingCart;